 <template>
   <div id="app">
     <router-view />
   </div>
 </template>
 <script>
 export default {
   name: 'App',
   created() {
     this.$ls.set('timeNum',60 * 1000 * 1); //设置模块倒计时时间间隔 60 * 1000 * 5
     console.log('App created');
   }
 }
 </script>



// WEBPACK FOOTER //
// src/App.vue